import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { 
	adminProductReviewFormRowData, 
	adminProductReviewFormTitle,
	adminProductReviewTableData, 
	adminProductReviewFormIsLoading, 
	adminProductReviewSkuMappingData,
	adminProductReviewFormIsSkuMappingData,
	brandForm, 
	skuForm, 
	siteForm,
} from "../@signals"


export default function useAdminProductReviewForm(dataRow={}) {
	const { showToast } = useToast()

	const handleOpenForm = useCallback(() => batch(() => {
		adminProductReviewFormTitle.value = dataRow.productName
		brandForm.value = dataRow.brandID ?? null
		skuForm.value = dataRow.skuID ?? null
		siteForm.value = { siteID: dataRow.siteID, siteCountry: dataRow.country }
		adminProductReviewFormRowData.value = dataRow
	}), [JSON.stringify(dataRow)])

	const handleSendToBack = useCallback((extraData={}, callback={}) => {
		showToast.promise(postSubmit(`${BACKEND_APIS.ADMIN}/product-review/update-mapping`, {
			item: {...dataRow, ...adminProductReviewFormRowData.value}, mapping: { ...dataRow, ...extraData}
		}), callback)
	}, [JSON.stringify(dataRow)])

	const handleUpdate = useCallback(() => {
		const myID = adminProductReviewFormRowData.value.id
		adminProductReviewFormIsLoading.value = myID

		handleSendToBack({
			...adminProductReviewFormRowData.value,
			brandID: brandForm.value || null,
			skuID: Array.isArray(skuForm.value) ? null : skuForm.value,
			qa: true, validated: true
		},  {
			onSuccess: newRow => {
				if (!adminProductReviewFormIsSkuMappingData.value)
					adminProductReviewTableData.value = adminProductReviewTableData.value.map(row => row.id === myID ? newRow : row)
				else
					adminProductReviewSkuMappingData.value = adminProductReviewSkuMappingData.value.map(row => row.id === myID ? newRow : row)
				return 'Data loaded'
			},
			onFinish: () => adminProductReviewFormIsLoading.value = null
		})
	}, [JSON.stringify(dataRow)])

	return {
		isOpenEditDrawer: adminProductReviewFormRowData.value.id === dataRow.id,
		isLoadingDrawer: adminProductReviewFormIsLoading.value === dataRow.id,
		handleOpenForm,
        handleSendToBack,
        handleUpdate
	}
}